import React from 'react';
import { IconButton, Paper, Tooltip } from '@mui/material';
import useTranslate from '../../Hooks/useTranslate';

const Fab = function Fab({
  id = 'custom-fab',
  title,
  onClick,
  href,
  children,
  sx,
  size,
  disabled,
}) {
  const translate = useTranslate();
  return (
    <Paper sx={{ borderRadius: '50px', ...sx }}>
      <Tooltip title={translate(title)} placement="bottom">
        <IconButton
          id={id}
          href={href}
          target="_blank"
          onClick={onClick}
          size={size}
          disabled={disabled}
        >
          {children}
        </IconButton>
      </Tooltip>
    </Paper>
  );
};

export default Fab;
